import { RepairHistorySectionDto } from '../types/models.types';
import { formatDateToDDMMYYYY } from './car-basic-info.mapper';

export interface MappedRepairHistoryItem {
  /** Miejsce naprawy (np. numer SKP, nazwa warsztatu) */
  repairPlace: string | null;
  /** Data naprawy w formacie DD/MM/YYYY */
  repairDate: string | null;
  /** Przebieg pojazdu w momencie naprawy */
  carMileage: string | null;
  /** Opis naprawionego elementu */
  repairedCarElement: string | null;
}

export interface MappedRepairHistorySection {
  /** Lista pozycji historii napraw */
  historyItems: MappedRepairHistoryItem[];
  /** Czy brakuje historii serwisowej */
  serviceHistoryMissing: boolean;
  /** Podsumowanie rzeczoznawcy dotyczące historii napraw */
  expertSummary: string | null;
}

export const mapRepairHistorySectionToUI = (
  section: RepairHistorySectionDto | null | undefined,
): MappedRepairHistorySection | null => {
  if (!section) {
    return null;
  }

  const mappedHistoryItems: MappedRepairHistoryItem[] = (section.historyItems || []).map((item) => ({
    repairPlace: item.repairPlace || null,
    repairDate: item.repairDate ? formatDateToDDMMYYYY(item.repairDate) : null,
    carMileage: item.carMileage || null,
    repairedCarElement: item.repairedCarElement || null,
  }));

  return {
    historyItems: mappedHistoryItems,
    serviceHistoryMissing: section.serviceHistoryMissing || false,
    expertSummary: section.expertSummary || null,
  };
};
